import { render, staticRenderFns } from "./InvestorOnboardingLegalRepCheckData.vue?vue&type=template&id=653fd1e4&scoped=true&"
import script from "./InvestorOnboardingLegalRepCheckData.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingLegalRepCheckData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingLegalRepCheckData.vue?vue&type=style&index=0&id=653fd1e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fd1e4",
  null
  
)

export default component.exports